"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Accordion_1 = require("../common/Accordion");
var hooks_1 = require("preact/hooks");
var ingredients_1 = require("../../utils/shopify-graphql/ingredients");
var path_1 = require("../../utils/shopify/path");
var color_1 = require("../common/color");
var CtaButton_1 = require("../common/Btn/CtaButton");
var Parser_1 = require("../Parser");
var UroVpIngredients_1 = require("./UroVpIngredients");
var Ingredients = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = (0, hooks_1.useState)(null), data = _h[0], setData = _h[1];
    var _j = (0, hooks_1.useState)(0), tab = _j[0], setTab = _j[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, ingredients_1.getIngredientsData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    var style = function (isSelected) {
        return data
            ? {
                color: (0, color_1.toHex)(isSelected ? 'white' : data.color),
                background: isSelected ? (0, color_1.toHex)(data.color) : 'transparent',
                'border-color': (0, color_1.toHex)(data.color),
            }
            : {};
    };
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("div", null,
        (0, preact_1.h)("div", { className: "ingredients" },
            (0, preact_1.h)("img", { className: "ingredients__header-img hide-on-desktop", src: (_a = data.ingredientsTabs.at(tab)) === null || _a === void 0 ? void 0 : _a.mobileImage }),
            (0, preact_1.h)("img", { className: "ingredients__header-img hide-on-mobile", src: (_b = data.ingredientsTabs.at(tab)) === null || _b === void 0 ? void 0 : _b.desktopImage }),
            (0, preact_1.h)("div", { className: "ingredients__padding-container" },
                data.ingredientsTabs.length > 1 && ((0, preact_1.h)("div", { className: "faq__button-container faq__button-container--v2" }, data.ingredientsTabs.map(function (x, i) { return ((0, preact_1.h)("button", { key: i, className: "faq__button", style: style(tab === i), onClick: function () { return setTab(i); } }, x.title)); }))),
                (0, preact_1.h)("p", { className: "ingredients__key-ingredients", style: data.color ? { color: (0, color_1.toHex)(data.color) } : '' }, "Key Ingredients:"),
                ((_d = (_c = data.ingredientsTabs) === null || _c === void 0 ? void 0 : _c.at(tab)) === null || _d === void 0 ? void 0 : _d.title) == 'Vaginal Probiotic' ? ((0, preact_1.h)(UroVpIngredients_1.default, { hideContent: true })) : ((_g = (_f = (_e = data.ingredientsTabs) === null || _e === void 0 ? void 0 : _e.at(tab)) === null || _f === void 0 ? void 0 : _f.ingredients) === null || _g === void 0 ? void 0 : _g.map(function (i) { return ((0, preact_1.h)(Accordion_1.default, { key: i.title, title: (0, preact_1.h)("div", { className: "ingredients__header-content" },
                        (0, preact_1.h)("img", { className: "ingredients__img", src: i.iconImg }),
                        (0, preact_1.h)("div", { className: "ingredients__header-text-container" },
                            (0, preact_1.h)("p", { className: "ingredients__title" }, i.title),
                            (0, preact_1.h)("p", { className: "ingredients__used-for" },
                                i.usedForLabel,
                                " ",
                                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                                (0, preact_1.h)("span", { className: "ingredients__claims" }, i.usedFor)))), body: (0, preact_1.h)("p", { className: "ingredients__description" }, (0, Parser_1.parse)(i.description)), startOpen: true })); })),
                location.pathname.includes('endocrine') && ((0, preact_1.h)("a", { className: "ingredients__see-all", href: "#anchor--ingredient-facts" }, "See All Ingredients")),
                (0, preact_1.h)("div", { className: "ingredients__footer-container" },
                    (0, preact_1.h)(CtaButton_1.default, { text: "SHOP NOW", textColor: data.ctaColor.text, backgroundColor: {
                            to: 'Left',
                            startColor: data.ctaColor.backgroundStart || 'white',
                            endColor: data.ctaColor.backgroundEnd || 'white',
                        }, hoverColor: data.ctaColor.hover || 'white' }))))));
};
exports.default = Ingredients;
